export enum InternshipsRoutingEnum {
  View = ':internshipId',
  Offer = 'deposer-offre',
  Apply = ':internshipId/postuler',
}
